import { ADPResourceService } from 'digital-core';

export interface INoticeBanner {
  noticeText: string;
  enrollText: string;
  redirectUrl: string;
  title: string;
}

export const getNoticeText = (bannerResourceKeysPrefix: string, adpResourceService: ADPResourceService): INoticeBanner => {
  const noticeBanner: INoticeBanner = {
    title: adpResourceService.transformContentData(adpResourceService.getViewLabel(`${bannerResourceKeysPrefix}_NoticeBanner_Title`)),
    noticeText: adpResourceService.transformContentData(adpResourceService.getViewLabel(`${bannerResourceKeysPrefix}_NoticeBanner_Message`)),
    enrollText: adpResourceService.transformContentData(adpResourceService.getViewLabel(`${bannerResourceKeysPrefix}_NoticeBanner_UrlDisplayText`)),
    redirectUrl: adpResourceService.getPortalSetting(`${bannerResourceKeysPrefix}_NoticeBanner_URL`).Value,
  };

  return noticeBanner;
};
